@@ -0,0 +1,78 @@
<template>
  <material-card
    :title="$t('components.vuematerialdashboard.core.appbar.providers')"
    icon="folder_shared"
    v-if="options"
  >
    <!-- <template v-slot:actions>
      <div style="margin-right:20px;margin-top: 10px;">
        <v-btn @click="dialogs.importBenefits = true" color="primary">
          {{ $t("components.guides.import_benefits_dialog.import_benefits") }}
        </v-btn>
      </div>
    </template> -->
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      @error="error = $event"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      :exporters="$exporters"
      fileNamePrefix="providers_index"
      identifier="providers_index"
      @itemsChanged="setData($event)"
    ></pbas-data-table>
    <!-- <import-benefits-dialog
      @close="
        dialogs.importBenefits = false;
        item = null;
      "
      @success="
        dialogs.importBenefits = false;
        message = $event;
        snackbar = true;
        $refs.table.getDataAsync();
      "
      :model="dialogs.importBenefits"
    /> -->
    <provider-office-dialog
      @close="
        dialogs.office = false;
        providerOffice = null;
        selected = null;
      "
      :model="dialogs.office"
      :item="providerOffice"
      :isDental="selected && selected.ProviderType === 'Dental'"
      :email="selected ? selected.Email : null"
      :providerId="selected ? selected.Id : null"
      @saved-billing-info="updateFromBillingInfo"
    />
    <provider-dialog
      :model="dialogs.add"
      @close="dialogs.add = false"
      type="Dental"
      @saved="
        dialogs.add = false;
        $refs.table.getDataAsync();
      "
    />
    <provider-dialog
      :model="dialogs.edit"
      @saved="
        dialogs.edit = false;
        $refs.table.getDataAsync();
      "
      :item="item"
      type="Dental"
      @close="dialogs.edit = false"
    />
    <!-- <update-billing-info
      :model="dialogs.billing"
      @close="
        dialogs.billing = false;
        $refs.table.getDataAsync();
      "
      :providerId="provider.Id"
      :officeId="provider.Id"
    /> -->
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        :title="deleteTitle"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </material-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getProvidersHeaders from "@/headers/ProvidersIndex";
import ErrorHandler from "@/components/ErrorHandler";
// import ImportBenefitsDialog from "@/components/Benefits/ImportBenefitsDialog";
import ProviderOfficeDialog from "@/components/NewProviders/ProviderOfficeDialog";
import { translate2 } from "../../trans2";
import ProviderDialog from "../Claims/ProviderDialog.vue";
export default {
  components: {
    ErrorHandler,
    // ImportBenefitsDialog,
    ProviderOfficeDialog,
    ProviderDialog,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      dialogs: {
        importBenefits: false,
        edit: false,
        delete: false,
        office: false,
        add: false,
      },
      item: null,
      selected: null,
      deleteTitle: "",
      selectActions: [
        // {
        //   name: "delete",
        //   icon: "delete",
        //   title: "globals.delete",
        //   handler: (items) => {
        //     this.selected = items;
        //     this.deleteTitle = this.$t(
        //       "components.benefits.benefits_table.delete_selected_benefits"
        //     );
        //     this.dialogs.delete = true;
        //   },
        // },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.dialogs.add = true;
          },
        },
      ],
      rowActions: [
        // {
        //   name: "edit",
        //   icon: "edit",
        //   title: "components.new_providers.providers_table.update_billing_info",
        //   handler: (item) => {
        //     this.item = JSON.parse(JSON.stringify(item));
        //     this.dialogs.edit = true;
        //   },
        //   visible: (item) => item.ProviderType === "Dental",
        // },
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.dialogs.edit = true;
            console.log(JSON.stringify(this.item));
          },
          visible: (item) =>
            item.ProviderType === "Dental" && item.ImportType === "Manual",
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.selected = item;
            this.deleteTitle = this.$t(
              "components.new_providers.providers_table.delete_provider_{0}",
              [item.FirstName + " " + item.LastName]
            );
            this.dialogs.delete = true;
          },
          visible: (item) =>
            item.ProviderType === "Dental" && item.ImportType === "Manual",
        },
      ],
      providerOffice: null,
      providers: [],
      message: "",
      snackbar: false,
      btnListeners: [],
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
    }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    options: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    if (this.options) {
      this.loadData();
    }
  },
  beforeDestroy() {
    this.btnListeners.forEach(({ btn, listener }) => {
      btn.removeEventListener("click", listener);
    });
  },
  methods: {
    ...mapActions("claims", ["deleteProvider", "getProviderOffice"]),
    loadData() {
      this.provider = new ODataProvider(
        this.$axiosHttp,
        this.settings.APIURL + "providers",
        getProvidersHeaders(this.options.Enums.Coverage)
      );
    },
    async tryDelete() {
      try {
        this.saving = true;
        await this.deleteProvider({
          providerId: this.selected.Id,
        });
        this.dialogs.delete = false;
        this.message = "globals.success";
        this.snackbar = true;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    openOffice(providerId, officeId) {
      // this.loading = true;
      // try {
      //   this.providerOffice = (await this.getProviderOffice({
      //     providerId: providerId,
      //     officeId: officeId,
      //   })).data;
      //   this.dialogs.office = true;
      // } catch (error) {
      //   this.error = error;
      // } finally {
      //   this.loading = false;
      // }
      this.selected = this.providers.filter((o) => o.Id === providerId)[0];
      this.providerOffice = this.selected.ProviderOffices.filter(
        (o) => o.OfficeId === officeId
      )[0];
      this.dialogs.office = true;
    },
    setData(data) {
      this.providers = data;
      this.$nextTick(() => {
        for (let provider of data) {
          console.log(provider);
          for (let providerOffice of provider.ProviderOffices) {
            console.log(providerOffice);
            let btn = document.getElementById(
              `${providerOffice.ProviderId}:${providerOffice.OfficeId}`
            );
            console.log(btn);
            const listener = () =>
              this.openOffice(
                providerOffice.ProviderId,
                providerOffice.OfficeId
              );
            btn.addEventListener("click", listener, false);
            this.btnListeners.push({ btn, listener });
          }
        }
      });
    },
    updateFromBillingInfo(billingInfoItem) {
      this.providerOffice.AccountNumber = billingInfoItem.AccountNumber;
      this.providerOffice.TransitNumber = billingInfoItem.TransitNumber;
      this.providerOffice.InstitutionNumber = billingInfoItem.InstitutionNumber;
      this.selected.Email = billingInfoItem.Email;
      this.$refs.table.getDataAsync();
    },
  },
};
</script>
